declare const Buffer: any;

import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

// ----------------------------
// LocalStorage Auto Expiry Setup
// ----------------------------

// // Determine expiry based on environment
// let EXPIRY_DURATION: number | null = null;

// if (environment.envName === 'stage') {
//   EXPIRY_DURATION = 20 * 60 * 1000; // 20 minutes
// } else if (environment.envName === 'prod') {
//   EXPIRY_DURATION = 7 * 24 * 60 * 60 * 1000; // 1 week
// }

// // Save original functions
// const originalSetItem = localStorage.setItem;
// const originalGetItem = localStorage.getItem;

// // Override setItem → wrap with expiry only for stage/prod
// localStorage.setItem = function (key: string, value: string) {
//   if (EXPIRY_DURATION !== null) {
//     const item = {
//       value,
//       expiry: Date.now() + EXPIRY_DURATION
//     };
//     originalSetItem.call(localStorage, key, JSON.stringify(item));
//   } else {
//     originalSetItem.call(localStorage, key, value); // dev: save plain
//   }
// };

// // Override getItem → auto-remove expired only for stage/prod
// localStorage.getItem = function (key: string) {
//   const itemStr = originalGetItem.call(localStorage, key);
//   if (!itemStr) return null;

//   if (EXPIRY_DURATION === null) return itemStr; // dev: return plain

//   try {
//     const item = JSON.parse(itemStr);
//     if (item.expiry && Date.now() > item.expiry) {
//       localStorage.removeItem(key);
//       return null;
//     }
//     return item.value;
//   } catch {
//     return itemStr; // fallback if old data is plain string
//   }
// };

// // Optional: cleanup old expired keys on startup (only stage/prod)
// if (EXPIRY_DURATION !== null) {
//   Object.keys(localStorage).forEach(key => {
//     const itemStr = originalGetItem.call(localStorage, key);
//     if (itemStr) {
//       try {
//         const item = JSON.parse(itemStr);
//         if (item.expiry && Date.now() > item.expiry) {
//           localStorage.removeItem(key);
//         }
//       } catch {}
//     }
//   });
// }

// ----------------------------
// Bootstrap Angular
// ----------------------------
platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch(err => console.error(err));

// Fix for passive touch event warnings
document.addEventListener(
  'touchstart',
  () => { },
  { passive: false }
);

// Make environment name available to index.html
(window as any)['APP_ENV'] = environment.envName;
